// Copy of the "Machines" walkthrough. The rules every text follows are in ../../de/help.js.
// Tab and field names are written as the machine page shows them (../machine.js).
// Twin file: help/materials.js. A change here nearly always belongs there too.
export default {
  title: "Machines",
  // Short names of the views, for the header, the timeline and "Continue to …".
  section: {
    MachineOverview: "Overview",
    MachineDetail: "Machine",
    CustomerDetail: "Customer prices",
    PacketDetail: "Packet",
    ProjectDetail: "Project",
    ProjectCostsForOne: "Project costs",
  },
  related: "Connections",
  step: {
    list: {
      text: "This is your company's machine fleet. A click on a row opens that machine.",
    },
    row: {
      text: "A row shows the name, the purchase price per unit and when the machine was last changed.",
    },
    create: {
      text: "Create new offers both: create new machine opens the empty form. It needs a name and a unit.",
    },
    "kind-filter": {
      text: "Machines and packets share one table, and the filter above it shows just one of the two. A packet bundles several machines for a project or a customer.",
    },
    head: {
      text: "The head carries the machine's icon and its name. The actions for this record sit on the right.",
    },
    "action-duplicate": {
      text: "Duplicate opens a new machine with the same details and prices. You change only what differs and save.",
    },
    "action-packet": {
      text: "Create packet from this starts a new packet. This machine is already its first position.",
    },
    tabs: {
      text: "Three tabs divide the page up. Which tab is open is part of the page's address.",
    },
    base: {
      text: "The name and the billing unit are the master data. You pick hour or day, and the purchase price refers to it.",
    },
    purchase: {
      text: "The purchase price is per unit. If you pay different suppliers different amounts, add several named purchase prices; one of them is the default. Each price picks its own currency, and a project only costs the price in its own currency.",
    },
    note: {
      text: "The note is for an internal remark. It belongs to the machine, not to a single project.",
    },
    files: {
      text: "File storage is for manuals and inspection records. A due date changes colour as it comes closer.",
    },
    activity: {
      text: "Activity shows where this machine is used, and below that every change with its day and who made it.",
    },
    save: {
      text: "Save writes every tab at once. A tab with an error in it is brought to the front.",
    },
    again: {
      text: "This button is on every page that has an explanation. One click starts it again.",
    },
    // Setup: what a machine does outside the catalogue.
    "customer-price": {
      text: "For one customer you set a selling price of its own. A fixed price may apply per day even when the machine costs per hour.",
    },
    "packet-items": {
      text: "A packet bundles several machines. A project or a customer takes them all over in one step.",
    },
    "project-machines": {
      text: "A project holds the selling price beside the purchase price. Cost and revenue each convert the time of use into their own unit.",
    },
    "project-report": {
      text: "A machine is booked on the Machines tab of [[hwr:a/an]] [[hwr]], one line per device, with its device number and hours. A day rate counts every started day of use.",
    },
    "project-costs": {
      text: "A project's cost structure shows what share of its cost is machines. Every booked usage is valued at the purchase price fixed when its report was saved.",
    },
  },
}
